import Vue from 'vue'
import Vuex from 'vuex'

// import questions from '@/data/questions.json';
// import scenarios from '@/data/scenarios.json';
// import results from '@/data/results.json';

import data from './data/data.json';

import merge from 'lodash.merge';

Vue.use(Vuex);

const CONSTANTS = {
  money: 500,
  time: 60,
  pain: 0,
  background: '#fff',
  backgroundImages: {
    question: 'url(' + require('@/assets/img/answer-bg.svg') + ')',
    welcome: 'url(' + require('@/assets/img/greetings-bg.svg') + ')',
    result: 'url(' + require('@/assets/img/result-bg.svg') + ')',
    resultFail: 'url(' + require('@/assets/img/result-bg_dark.svg') + ')',
  },
  scoreTypes: ['money','time','pain'], // Массив описывающий типы очков(счёта)
  scenariosTypes: ['newbies','more12years','prettyGood','top5']
}

export default new Vuex.Store({
  state: {
    strict: process.env.NODE_ENV !== 'production',
    constants: CONSTANTS,
    scenariosData: data.scenarios,
    firstQuestion: data.firstQuestion[0],
    questionsData: data.questions,
    resultsData: data.results,
    isFail: false,
    activePage: 'welcome',
    activeQuestion: 0,
    activeScenario: null,
    modificator: {
      money: 0,
      time: 0,
      pain: 0
    },
    base: 50, // Базовое количество баллов. Некий коэффициент сложности
    score: {
      money: CONSTANTS.money,
      time: CONSTANTS.time,
      pain: CONSTANTS.pain,
    },
    backgroundColor: CONSTANTS.background,
    backgroundImage: CONSTANTS.backgroundImages['welcome']
  },
  getters: {
    questLength(state) {
      return state.questionsData.length;
    },
    isFirstQuestion(state) {
      return state.activeScenario === null
    },
    isEnd(state, getters) {
      if(getters.isZeroMoneyTime || getters.isTooMuchPain && !getters.isLastQuestion) {
        state.isFail = true;
      }
      return getters.isZeroMoneyTime || getters.isTooMuchPain || getters.isLastQuestion;
    },
    isZeroMoneyTime(state) {
      return state.score.money <= 0 || state.score.time <= 0;
    },
    isTooMuchPain(state) {
      return state.score.pain >= 100;
    },
    isLastQuestion(state, getters) {
      return state.activeQuestion + 2 > getters.questLength
    },
    getAnswers(state) {
      let id = state.activeQuestion;
      let answers = null;

      if(state.activeScenario) {
        answers = state.scenariosData[state.activeScenario][id].answers;
      } else {
        answers = state.questionsData[id].answers;
      }

      // Выставляем все ответы в состояние "не выбран"
      answers.forEach( item => item.choosed = false );

      return answers;
    },
    getStatus(state) {
      return state.score;
    },
    getResults(state) {
      return state.resultsData;
    },
    currQuest(state, getters) {
      let id = 0;
      let currQuest = {};

      if(getters.isFirstQuestion) {
        currQuest = {
          ...state.firstQuestion
        }
      } else {
        let tempQuestionData = {};
        id = state.activeQuestion;
        tempQuestionData = {
          id: id,
          answers: getters.getAnswers
        }
        currQuest = merge(state.questionsData[id], tempQuestionData);
      }
      return currQuest;
    },
  },
  mutations: {
    restartGame(state) {
      state.score.money = state.constants.money;
      state.score.time = state.constants.time;
      state.score.pain = state.constants.pain;
      state.backgroundColor = state.constants.background;
      state.activeQuestion = 0;
      state.activeScenario = null;
      state.isFail = false;

      this.commit('changePage', 'question');
    },
    calcModificators(state) {
      state.modificator.money = (state.constants.money * 2) / state.base;
      state.modificator.time = (state.constants.time * 2) / state.base;
      state.modificator.pain = 100 / state.base;
    },
    changePage(state, page) {
      state.activePage = page;
      this.commit('changeBackgroundColor');
      this.commit('changeBackgroundImage', page);

      if(page === 'question') {
        // eslint-disable-next-line
        fbq('trackCustom', 'startGame');
      }
    },
    changeBackgroundImage(state, page) {
      if(state.isFail) {
        page = 'resultFail';
      }
      state.backgroundImage = state.constants.backgroundImages[page];
    },
    changeBackgroundColor(state) {
      let isQuestionPage = state.activePage === "question" && !this.getters.isFirstQuestion;
      state.backgroundColor = isQuestionPage ? this.getters.currQuest.background : '#fff';
    },
    setChoosedAnswer(state, id) {
      this.getters.currQuest.answers[id].choosed = true;
    },
    setScenarios(state, id) {
      state.activeScenario = CONSTANTS.scenariosTypes[id];
      state.activeQuestion = 0;
    },
    nextQuestion(state) {
      if(this.getters.isEnd) {
        this.commit('changePage','result');
        return;
      }
      state.activeQuestion++;
      this.commit('changePage','question');
    },
    changeScore(state, data) {
      const {
        type,
        value
      } = data;

      let typeName = CONSTANTS.scoreTypes[type];

      switch(typeName) {
        case 'money':
          this.commit('changeMoney', value);
          break;
        case 'time':
          this.commit('changeTime', value);
          break;
        case 'pain':
          this.commit('changePain', value);
          break;
      }

    },
    changeMoney(state, value) {
      if(value < state.constants.money) {
        state.score.money -= value * state.modificator.money;
      } else {
        state.score.money = value * state.constants.money;
      }
    },
    changeTime(state, value) {
      if(value < state.constants.time) {
        state.score.time -= value * state.modificator.time;
      } else {
        state.score.time = value * state.constants.time;
      }
    },
    changePain(state, value) {
      if(value > state.constants.pain) {
        state.score.pain += value * state.modificator.pain;
      } else {
        state.score.pain = value * state.constants.pain;
      }
    }
  }
});
